const React = require('react');
const connect = require('react-redux').connect;
const actions = require('../../action/dish-menu/dish-menu');
const shallowCompare = require('react-addons-shallow-compare');
const findDOMNode = require('react-dom').findDOMNode;

require('../../asset/style/style.scss');
require('./application.scss');

const DishTypeScroller = require('../../component/dish-menu/dish-type-scroller.jsx');
const DishScroller = require('../../component/dish-menu/dish-scroller.jsx');
const DishGuid = require('../../component/dish-menu/dish-guid.jsx');
const CartContainer = require('../../component/dish-menu/cart/cart-container.jsx');
const Toast = require('../../component/mui/toast.jsx');
const DishMesthead = require('../../component/dish-menu/dish-mesthead.jsx');
const SearchDish = require('../../component/dish-menu/search-dish.jsx');
const MessageDialog = require('../../component/mui/dialog/message-dialog.jsx');
const helper = require('../../helper/dish-helper');
const commonHelper = require('../../helper/common-helper');
const type = helper.getUrlParam('type');
const Loading = require('../../component/mui/loading.jsx');
const shopCloseImg = require('../../asset/images/yidayang.svg');
import QuickMenu from '../../component/dish-menu/cart/quick-menu';
import DishHotSlide from '../../component/dish-menu/dish-hot-slide';
import ReceiveCoupons from '../../component/common/receive-coupons';
import DishDetailContainer from '../../component/dish-menu/detail/dish-detail-container.jsx';
import PreloadSkeleton from '../../component/dish-menu/preload-skeleton';
import FloatingNavigation from '../../component/common/floating-navigation.jsx';
import DishCouponSuccess from '../../component/dish-menu/dish-coupon-success.jsx';
import GoodsDetailModal from './components/goods-detail-modal';
import commonActions from '../../action/common-action/common-action';
import { bindActionCreators } from 'redux';
import { initWXShareEventWithConfig } from '../../helper/wx-share-config.js';
import { WxSharEventEntry } from '../../helper/const.js';
import FormattedMessage from '../../intl/formatted-message';
import { formatMessage } from '../../intl/helper';
import containnerText1 from '../../intl/messages/container/part1';
import buttonMessages from '../../intl/messages/button';
import shopMessages from '../../intl/messages/shop';
import globalMessages from './../../intl/messages/global';
import dishMenuText from '../../intl/messages/dish-menu';
import { getTableInfoInSessionStorage } from '../../helper/order-dinner-cart-helper.js';
import FullscreenAd from '../../component/fullscreen-ad';
import { setIndustryToBody } from '../../helper/industry-helper.js';
import ccbAppHelper from '../../helper/Ccb-app-helper';
import ebuHelper from '../../helper/Ebu-app-helper';

import HealthIcon from '../../component/health-icon';
import SelfChooseMustOrderCategory from '../../component/dish-menu/self-choose-must-order-category';

const { isFormalMeal, dateUtility } = commonHelper;
const isWeiXinMiniBrowser = commonHelper.isWechatMiniProgramBrowser();
const shopId = helper.getUrlParam('shopId');

const DishMenuApplication = React.createClass({
  displayName: 'DishMenuApplication',
  propTypes: {
    // MapedActionsToProps
    fetchMenuData: React.PropTypes.func.isRequired,
    fetchSoldDishList: React.PropTypes.func.isRequired,
    fetchTableInfo: React.PropTypes.func.isRequired,
    fetchSendArea: React.PropTypes.func.isRequired,
    activeDishType: React.PropTypes.func.isRequired,
    orderDish: React.PropTypes.func.isRequired,
    toggleDishDetailPopup: React.PropTypes.func.isRequired,
    toggleDishDescPopup: React.PropTypes.func.isRequired,
    gotoGoodsDetailPage: React.PropTypes.func.isRequired,
    confirmOrder: React.PropTypes.func.isRequired,
    removeAllOrders: React.PropTypes.func.isRequired,
    reinstateUndefined: React.PropTypes.func.isRequired,
    fetchOrderDiscountInfo: React.PropTypes.func.isRequired,
    fetchOrderAgain: React.PropTypes.func.isRequired, // 再来一单
    clearErrorMsg: React.PropTypes.func.isRequired,
    shopInfo: React.PropTypes.object.isRequired,
    fetchDishMarketInfos: React.PropTypes.func.isRequired,
    getMarketCoupons: React.PropTypes.func.isRequired,
    fetchShopInfo: React.PropTypes.func.isRequired,
    setPageLoadedStatus: React.PropTypes.func.isRequired,
    dataInitIsOver: React.PropTypes.func.isRequired,
    // MapedStatesToProps
    activeDishTypeId: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]).isRequired,
    activeDishTypeIdIndex: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]).isRequired,
    dishTypesData: React.PropTypes.array,
    dishesData: React.PropTypes.array,
    dishesDataDuplicate: React.PropTypes.array,
    dishDetailData: React.PropTypes.object,
    dishDescData: React.PropTypes.object,
    takeawayServiceProps: React.PropTypes.object,
    openTimeList: React.PropTypes.array,
    isAcceptTakeaway: React.PropTypes.bool,
    normalDiscountProps: React.PropTypes.object,
    discountProps: React.PropTypes.object,
    enableMemberRegistry: React.PropTypes.bool,
    dishPageTpl: React.PropTypes.string,
    shopLogo: React.PropTypes.string,
    errorMessage: React.PropTypes.object,
    load: React.PropTypes.object,
    tableAreaInfo: React.PropTypes.object,
    isAcceptOrder: React.PropTypes.bool,
    operateUrl: React.PropTypes.string,
    operateImgUrl: React.PropTypes.string,
    isHDL: React.PropTypes.bool,
    guide: React.PropTypes.bool,
    orderPageTitle: React.PropTypes.string,
    orderPageImage: React.PropTypes.string,
    wmCartImageUrl: React.PropTypes.string,
    tsCartImageUrl: React.PropTypes.string,
    pageIsLoaded: React.PropTypes.bool,
    soldTopDishList: React.PropTypes.array,
    getCoupontoGuid: React.PropTypes.func,
    guidStatus: React.PropTypes.bool,
    setErrorMsg: React.PropTypes.func,
    couponSuccess: React.PropTypes.bool,
    brandInfo: React.PropTypes.object,
    changed: React.PropTypes.bool,
    fetchMustOrderMenu: React.PropTypes.func,
  },

  childContextTypes: {
    brandType: React.PropTypes.string,
  },

  getChildContext() {
    const { brandInfo = {} } = this.props;
    return { brandType: brandInfo.brandType };
  },

  getDefaultProps() {
    return {
      dishPageTpl: 'default',
    };
  },

  getInitialState() {
    return {
      isMinMesthead: false,
      isShowSearch: false,
      allDiscount: null, // 设置弹出层
      showUnpaidPrompt: true,
      showDishCouponSuccess: true,
      showFixedCoupon: true, // 默认领券弹出层
      showHotDish: false,
      handleInput: false,
      dishItem: {},
      showCouponList: false,
      isShowOpenStatus: true, // 是否展示已打烊对话框
      floatingNavigationStatus: true, // 是否展示导航按钮
      isShowLoginExceptionDialog: false, // 建行登录异常模态框显示与否
      showLoginExceptionDesc: '登录异常，不可点餐', // 建行登录异常模态框显示与否
      orderAgain: false, // 再来一单标识
      showMessage: true, // 关闭提示信息
      ebuIsShowLoginExceptionDialog: false, // 饿企登录异常模态框显示与否
      showGoodsDetailModal: false, // 是否显示菜品详情modal
      currentDishId: null, // 点击的菜品Id
      showSelfChoose: false, // 开台必点弹框
      showSelfChooseMsg: '', // 开台必点消息提示
    };
  },
  flyQueue: [],
  flyFree: true,

  componentWillMount() {
    this.canSlip = true;
    this.canFoldup = false;
    this.scrollTimeout = null;
    const { toggleDishDescPopup } = this.props;
    const { setErrorMsg } = this.props;

    commonHelper.getCommericalInfo(setErrorMsg, commericalInfo => {
      if (!commericalInfo.enablePortalStore) {
        setErrorMsg({
          text: formatMessage(containnerText1.OrderInlineApplicationoccluedMobileShop),
          timeout: -1,
        });
      }
    });
    window.addEventListener('hashchange', () => {
      const hash = location.hash;
      if (hash === '') {
        this.setHotViewAccordingToHash();
        toggleDishDescPopup();
      }

      if (hash && hash !== '#hot-dish' && hash !== '#dish-desc') {
        this.setHotViewAccordingToHash();
      }

      if (hash && hash !== '#dish-desc' && hash === '#hot-dish') {
        toggleDishDescPopup();
      }
    });

    window.addEventListener('load', () => {
      location.hash = '';
    });

    this._cache = {};
    if (sessionStorage.orderId) {
      // 再来一单需要清除原来缓存中的菜品再从order中获取菜品
      localStorage.removeItem('lastOrderedDishes');
    }
  },

  componentDidMount() {
    // 饿了么企餐屏蔽快速导航
    if (ebuHelper.isEbuEvn()) {
      this.getIsExpandCard(true);
    }

    sessionStorage.setItem('tagsType', type);
    const {
      fetchIndustryInfo, // brand/industry.json
      fetchMenuData, // orderall/dishAll.json
      fetchSoldDishList, // orderall/recommendDishList
      fetchSendArea, // orderType === 'WM'  user/getDefaultSendArea.json
      fetchOrderDiscountInfo, // shop/discountInfo.json
      fetchOrderAgain, // 再来一单
      fetchDishMarketInfos, // orderall/dishMarketInfos.json
      fetchTableInfo, // type === 'TS'  orderall/tableInfo.json
      fetchShopInfo, // TS: orderall/orderPageInfo.json (YDtime: prepare/dishAll.json)   WM: takeaway/orderPageInfo.json
      setPageLoadedStatus,
      dataInitIsOver,
      getServiceStatus,
      fetchMustOrderMenu, // 外卖 - 必点菜
    } = this.props;
    fetchSendArea();

    if (type === 'TS') {
      fetchTableInfo();
      // 建行App环境下，无感登录逻辑 外卖暂时不支持建行
      this.outComeInAndLoginLogic();
      // 饿了么企餐环境下，静默登录 只支持快餐
      this.ebuLoginAdaptation();
    }
    if (sessionStorage.orderId) {
      this.setState({
        orderAgain: true,
      });
    }
    fetchIndustryInfo().then(industry => {
      setIndustryToBody(industry);
    });

    fetchShopInfo()
      .then(fetchMenuData)
      .then(fetchSoldDishList)
      .then(() => {
        // setPageLoadedStatus(true);
      })
      .then(fetchOrderAgain)
      .then(fetchDishMarketInfos)
      .then(discountRule => fetchOrderDiscountInfo(discountRule))
      .then(() => {
        fetchMustOrderMenu().then(res => {
          this.setShowSelfChoose(res);
        });
        setPageLoadedStatus(true);
        dataInitIsOver(true);

        // this.scrollTimeout = setTimeout(() => {
        //   this.scrollToTop();
        // }, 1000);
        // 此处展示进店领券列表
        const { shopInfo } = this.props;
        if (
          (!shopInfo.isOldMarketing && shopInfo.couponList && shopInfo.couponList.length > 0) || // 新逻辑
          (shopInfo.isOldMarketing && shopInfo.marketCoupon && shopInfo.marketCoupon.coupId) // 旧逻辑
        ) {
          this.setState({ showCouponList: true });
        }

        // 正餐先付
        if (isFormalMeal(shopInfo.diningForm)) {
          const tableId = helper.getUrlParam('tableId');
          const tableKey = helper.getUrlParam('tableKey');

          getServiceStatus({ tableId, tableKey });
        }
      });

    if (this.props.fetchBrandInfo) {
      this.props.fetchBrandInfo();
    }
  },

  componentWillReceiveProps(nextProps) {
    const { loadShopStatus } = this.props;
    const { orderPageTitle, loadShopStatus: loadShopStatusNew } = nextProps;
    if (loadShopStatus !== loadShopStatusNew && loadShopStatusNew) {
      document.title = orderPageTitle || (type === 'WM' ? '外卖点餐' : '堂食点餐');
      this.title = document.title;
    }
    if (ebuHelper.isEbuEvn() || sessionStorage.getItem("ACCESS_FROM") === "ebu") {
      document.title = "饿了么企业订餐"
    };
  },
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  },

  componentDidUpdate() {
    
    const el = findDOMNode(this);

    initWXShareEventWithConfig({ entry: WxSharEventEntry.SHOP, _this: this });

    if (this._cache.mesthead) {
      return;
    }

    this._cache = {
      mesthead: el.querySelector('.dish-mesthead'),
      scrollerWrap: el.querySelector('.scroller-wrap'),
    };

    const tableId = helper.getUrlParam('tableId');
    const tableKey = helper.getUrlParam('tableKey');
    const isScanCodeFromPage = sessionStorage.getItem('isScanCodeFromConf') === 'true'; // 如果是客户配置了url参数为&scan=true

    // 判断是否是扫码点餐 如果是扫码点餐需要在本地写入localStorage
    if (tableId || tableKey || isScanCodeFromPage) {
      sessionStorage.isScanCode = true;
    } else {
      localStorage.removeItem('kcTableId');
    }
  },
  // 饿了么静默登录
  ebuLoginAdaptation() {
    const isEbuEvn = ebuHelper.isEbuEvn();
    let euId = null;
    if (!isEbuEvn) return Promise.resolve();
    if (helper.getUrlParam('euid')) {
      euId = helper.getUrlParam('euid');
    } else {
      euId = localStorage.getItem('euid');
    }
    ebuHelper
      .isLogin({ shopId, euId })
      .then()
      .catch(err => {
        this.setState({ ebuIsShowLoginExceptionDialog: true });
      });
  },
  outComeInAndLoginLogic() {
    const isCcbEvn = ccbAppHelper.isCcbEvn();
    if (!isCcbEvn) return Promise.resolve();

    const ccbParamSJ = helper.getUrlParam('ccbParamSJ'); // 建行传入参数
    const errMsg = formatMessage(globalMessages.urlLostInfo);
    ccbAppHelper
      .getUserIndividual({ shopId, ccbParamSJ, errMsg })
      .then()
      .catch(ex => {
        if (typeof ex === 'string') {
          this.setState({ showLoginExceptionDesc: ex });
        }
        this.setState({ isShowLoginExceptionDialog: true });
      });

    // return fetch(`${config.individualAPI}?shopId=${shopId}`, config.requestOptions)
    //   .then((res = {}) => {
    //     console.log('---res', res);
    //     if (!res.ok) {
    //       if (!ccbParamSJ) {
    //         throw formatMessage(globalMessages.urlLostInfo);
    //       }
    //       return ccbAppHelper
    //         .getUserInfo(ccbParamSJ)
    //         .then(userInfo => {
    //           return ccbAppHelper.login({ shopId, mobile: userInfo.mobile || '' });
    //         })
    //         .catch(ex => {
    //           throw ex;
    //         });
    //     }
    //   })
    //   .catch(ex => {
    //     console.error(ex);
    //     if (typeof ex === 'string') {
    //       this.setState({ showLoginExceptionDesc: ex });
    //     }
    //     this.setState({ isShowLoginExceptionDialog: true });
    //   });
  },

  onDishDetailAddBtnTap(dishData, increment, option) {
    const { orderDish, toggleDishDetailPopup } = this.props;
    const { lastSourceTapRect } = this._cache;
    toggleDishDetailPopup();
    if (lastSourceTapRect) {
      this.setState({ dropInShoping: false }, () => {
        this.startBallFlyQueue(lastSourceTapRect);
        this.ballFlyOutQueue();
        // setTimeout(() => {
        //   this.startBallFlyQueue(lastSourceTapRect);
        // }, 0);
      });
    }
    orderDish(dishData, increment, option);
  },

  onDishTouchTap(event) {
    const { target } = event;
    if (target.parentNode.className === 'counter') {
      this._cache.lastSourceTapRect = target.getBoundingClientRect();
      return;
    }
    if (target.className.indexOf('counter-click-mask') === -1 || target.parentNode.className.indexOf('counter-add') === -1) {
      return;
    }

    const rect = target.getBoundingClientRect();
    this.setState({ dropInShoping: false }, () => {
      this.startBallFlyQueue(rect);
      // setTimeout(() => {
      //   this.startBallFlyQueue(rect);
      // }, 0);
    });
  },

  setSearchPage(isShowSearch) {
    if (isShowSearch) {
      document.title = '搜索';
    } else {
      document.title = this.title;
    }

    this.setState({ isShowSearch });
  },

  setScrollTop(scrollTop) {
    const dishScrollerMain = document.querySelector('.dish-scroller-main');

    if (scrollTop < 0 && this.canSlip) {
      this.canSlip = false;
      this.canFoldup = true;

      this.methodAfterSlip();

      if (dishScrollerMain.scrollTop <= 0) {
        dishScrollerMain.scrollTop = 1;
      }
    } else if (scrollTop >= 0 && this.canFoldup) {
      this.canFoldup = false;
      this.canSlip = true;

      this.methodAfterFoldUp();
    }
  },

  // scrollToTop() {
  //   this.setScrollTop(-1);
  // },

  getSameRuleDishList(dish, dishList) {
    const { sameDishIndexs = [] } = dish;
    return sameDishIndexs.map(dishIndex => dishList[dishIndex]);
  },

  setAllDiscount(allDiscount) {
    this.setState({ allDiscount });
  },

  closeUnpaidDialog() {
    this.setState({
      showUnpaidPrompt: false,
    });

    sessionStorage.removeItem('unpaidOrderId');
  },
  startBallFlyQueue(start) {
    const { brandInfo } = this.props;
    if (brandInfo && brandInfo.brandId === '772998') {
      this.setState({ dropInShoping: true });
      return;
    }

    if (start && this.flyQueue.length < 1) {
      this.flyQueue.push(start);
      // else if (length === 2) {
      //   this.flyQueue[1] = start;
      // }
    }
    // this.ballFlyOutQueue();
  },
  ballFlyOutQueue() {
    if (this.flyFree && this.flyQueue.length > 0) {
      this.flyFree = false;
      this.startBallFly(this.flyQueue.shift());
    }
  },
  startBallFly(start) {
    this.setState({ dropInShoping: false });

    helper.ballFlyWhenOrderDish({
      speed: 2.8,
      start: {
        left: start.left - 20,
        top: start.top - 20,
      },
      end: {
        left: 20,
        top: window.innerHeight - 20,
      },
      className: 'ball',
      onEnd: () => {
        this.flyFree = true;
        this.setState({ dropInShoping: true });
        this.ballFlyOutQueue();
        // setTimeout(() => {
        //   this.setState({ dropInShoping: false });
        // }, 2000);
      },
    });
  },

  closeDishCouponSuccess() {
    this.setState({ showDishCouponSuccess: false });
  },

  methodAfterSlip() {
    this.setState({
      flodUpAppendCss: 'flodup',
    });
  },

  methodAfterFoldUp() {
    this.setState({
      flodUpAppendCss: '',
    });
  },

  closeFixedCoupon(evt) {
    new Promise((resolve, reject) => {
      this.props.getCoupontoGuid(true, resolve);
    }).then(() => {
      this.setState({ showFixedCoupon: false });
    });

    if (evt) {
      evt.preventDefault();
    }
  },

  // 热销菜品推荐
  showHotSpans(e) {
    this.setState({ showHotSpan: true });

    e.preventDefault();
    e.stopPropagation();
    location.hash = '#hot-dish';
  },

  cancelHotSpan(e) {
    this.setState({ showHotSpan: false });

    e.preventDefault();
    e.stopPropagation();
    location.hash = '';
  },

  setHotViewAccordingToHash() {
    this.setState({ showHotSpan: false });
  },

  getDishHotElement(data, dish) {
    const hotElement = [];

    if (data && dish) {
      data.forEach((temp, index) => {
        // 热销菜品
        dish.forEach((item, i) => {
          // 所有菜品
          if (String(temp.dishId) === String(item.id)) {
            hotElement.push(
              Object.assign({}, item, {
                soldNum: temp.soldNum || item.soldNum,
                index: i,
              }),
            );
          }
        });
      });
    }
    return hotElement;
  },

  getReceiveCouponsStatus(name) {
    // 是否能够出现弹出层表示进店领券
    const { shopInfo, isHDL } = this.props;
    let status = true;

    if (helper.getUrlParam('getCoupon')) {
      status = false;
    }

    if (shopInfo.isOldMarketing) {
      // 老逻辑标识已经领过券了
      const { marketCoupon = {} } = shopInfo;
      const { coupId } = marketCoupon || {};
      const alreadySendCouponOld = localStorage.alreadySendCouponOld || '';
      if (alreadySendCouponOld.indexOf(`${type}_${shopId}_${coupId}`) !== -1) {
        // WM_810005865_82847257400999936
        status = false;
      }
      if (shopInfo.marketCoupon && !shopInfo.marketCoupon.flag && (shopInfo.marketCoupon.type === 2 || shopInfo.marketCoupon.type === 1)) {
        status = false;
      }
    } else {
      // 新逻辑标识领券了
      const { ruleId, planId } = shopInfo;
      const alreadySendCouponNew = localStorage.alreadySendCouponNew || '';
      if (alreadySendCouponNew.indexOf(`${type}_${shopId}_${ruleId}_${planId}`) !== -1) {
        // WM_810005865_1111_2222
        status = false;
      }
      // flag 是否可以继续领券 type 类型(1：优惠券已领完，2:已达到每人最多领取张数)
      if ((!shopInfo.flag && (shopInfo.type === 1 || shopInfo.type === 2)) || shopInfo.couponSuccess) {
        status = false;
      }
    }

    // 海底捞 可以领券 门店未打烊 将不可以领券
    if (isHDL && status && !this.isShopClose()) {
      status = false;
    }

    return status;
  },

  hiddenCouponsList(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    this.setState({ showCouponList: false, isShowAlreadyGotCoupon: false });
  },

  showCouponsList(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    this.setState({ showCouponList: true });
  },

  showAlreadyGotCoupon(showStatus) {
    this.setState({ isShowAlreadyGotCoupon: showStatus });
  },

  handleItemImageTab(goods) {
    // 点击菜品图片打开modal
    // outdated this.props.gotoGoodsDetailPage(goods);
    this.setState(
      {
        currentDishId: goods.id,
      },
      () => {
        this.toggleGoodsdDetailModal();
      },
    );
  },

  handleOrderDishChange(dishData, action, needRender = true) {
    const { orderDish } = this.props;
    orderDish(dishData, action);
    setTimeout(() => {
      this.ballFlyOutQueue();
    }, 0);
  },

  isShopClose() {
    const { shopInfo, isAcceptOrder } = this.props;
    const { isEnableShop, openStatus, enableWeixinMini } = shopInfo;
    return !isEnableShop || !isAcceptOrder || !openStatus || (!enableWeixinMini && !!isWeiXinMiniBrowser);
  },

  isShowPreOrder() {
    // 是否显示底部'接受预定中'
    const orderType = helper.getUrlParam('type');
    if (orderType !== 'WM') return false;

    const { deliveryTime = '--' } = this.props;
    const { shopInfo } = this.props;
    const { openStatus, isAcceptTakeaway, isToHomeFlag } = shopInfo;
    if (deliveryTime === '--') {
      return false;
    }
    if (!openStatus && isAcceptTakeaway) {
      if (!isToHomeFlag || !deliveryTime) {
        return {
          isShowPreOrder: true,
          showMsg: formatMessage(shopMessages.acceptPreOrderIng, { ing: '' }),
        };
      }
      const stampStr = `${deliveryTime}:00`;
      const timeStamp = new Date(stampStr.replace(/-/g, '/')); // ios无法解析2012-12-12形式
      const isToday = dateUtility.format(new Date(), 'yyyy-MM-dd') === deliveryTime.split(' ')[0];
      const startTime = deliveryTime.split(' ')[1];
      const year = timeStamp.getFullYear();
      const month = timeStamp.getMonth() + 1;
      const date = timeStamp.getDate();
      if (isToday) {
        // 当天配送不用显示日期
        const orderMsg = formatMessage(shopMessages.sendDateToday, { startTime });
        return {
          isShowPreOrder: true,
          showMsg: `${formatMessage(shopMessages.acceptPreOrderIng, { ing: '中' })}，${orderMsg}`,
        };
      }
      const orderMsg = formatMessage(shopMessages.sendDate, { year, month: Number(month), day: Number(date), startTime });
      return {
        isShowPreOrder: true,
        showMsg: `${formatMessage(shopMessages.acceptPreOrderIng, { ing: '中' })}，${orderMsg}`,
      };
    }
    return false;
  },

  renderOpenDialog(shopInfo, isAcceptOrder, openShopTime) {
    const { isShowOpenStatus } = this.state;
    const { isHDL } = this.props;
    const { isEnableShop, openStatus, enableWeixinMini, isAcceptTakeaway } = shopInfo;
    let closeWord = '';
    let enableCloseDialog = true;
    if (!enableWeixinMini && !!isWeiXinMiniBrowser) {
      closeWord = (
        <div className="shopopen-time">
          <FormattedMessage {...containnerText1.DishMenuApplicationmircAppUnOpen} />
        </div>
      );
      enableCloseDialog = false;
    } else if (!isEnableShop) {
      closeWord = (
        <div className="shopopen-time">
          <FormattedMessage {...shopMessages.isDisable} />
        </div>
      );
    } else if (!isAcceptOrder) {
      closeWord = (
        <div className="shopopen-time">
          <FormattedMessage {...shopMessages.isNotAcceptOrder} />
        </div>
      );
    } else if (!openStatus) {
      closeWord = (
        <div className="shopopen-time">
          <FormattedMessage {...shopMessages.openhour} />：{openShopTime || <FormattedMessage {...shopMessages.notConfig} />}
        </div>
      );
    }
    const hasCoupon = this.getReceiveCouponsStatus();
    const isAcceptOrderClose = !openStatus && isAcceptTakeaway; // 是否接受预定
    return (
      <div className="dish-mesthead-opendialog">
        {this.isShopClose() && isShowOpenStatus && !isAcceptOrderClose && (
          <MessageDialog
            onConfirm={() => {
              if (!enableCloseDialog) return;
              this.setState({ isShowOpenStatus: false });
            }}
            btnText={
              <span className={!enableCloseDialog ? 'shopopen-btn_disabled' : ''}>
                {isHDL && hasCoupon ? formatMessage(buttonMessages.receiveWelfare) : formatMessage(buttonMessages.iknown)}
              </span>
            }
          >
            <img className="shopopen-img" src={shopCloseImg} alt={formatMessage(shopMessages.closedFlag)} />
            <p className="shopopen-info">
              {isHDL && hasCoupon ? <FormattedMessage {...shopMessages.hdlHasCouponIsClose} /> : <FormattedMessage {...shopMessages.isClose} />}
            </p>
            {closeWord}
          </MessageDialog>
        )}
      </div>
    );
  },

  getIsExpandCard(expandCardStatus) {
    if (expandCardStatus) {
      this.setState({ floatingNavigationStatus: false });
      return;
    }

    this.setState({ floatingNavigationStatus: true });
  },
  clearErrorMsg() {
    this.setState({ showMessage: false, showSelfChooseMsg: '' });
  },

  toggleGoodsdDetailModal() {
    this.setState(({ showGoodsDetailModal }) => ({ showGoodsDetailModal: !showGoodsDetailModal }));
  },

  setShowSelfChoose(list) {
    if (Array.isArray(list) && !!list.length) {
      this.setState({
        showSelfChoose: true,
      });
    }
  },

  handleConfirmSelfChoose() {
    this.setState({ showSelfChoose: false });
  },

  setErrMsg(msg) {
    if (!msg || this.state.showSelfChooseMsg) return;
    this.setState({
      showSelfChooseMsg: msg,
    });
  },

  beforeConfirmOrder() {
    const { dishesDataDuplicate, selfChooseDishTypeObj = {}, confirmOrder, shopInfo = {} } = this.props;
    if (type !== 'WM' || !shopInfo.enableOpenDish) {
      confirmOrder();
      return;
    }
    const orderedData = helper.getOrderedDishes(dishesDataDuplicate);
    if (!orderedData) return;
    const orderDishIds = orderedData.map(item => item.id);

    // const isCheckedMustDish = Object.keys(selfChooseDishTypeObj).every(dishTypeId => {
    //   const dishMustLists = selfChooseDishTypeObj[dishTypeId].map(item => item.id) || [];
    //   return dishMustLists.some(id => orderDishIds.indexOf(id) !== -1);
    // });

    const noOrderDishTypeNameList = Object.keys(selfChooseDishTypeObj).reduce((all, dishTypeId) => {
      const dishMustIdLists = selfChooseDishTypeObj[dishTypeId].map(item => item.id) || []; // 当前中类所有菜品id
      const hasMustDish = dishMustIdLists.some(id => orderDishIds.indexOf(id) !== -1);
      if (!hasMustDish) {
        const dishList = selfChooseDishTypeObj[dishTypeId] || [];
        const dishTypeName = (dishList[0] || {}).dishTypeName;
        all.push(dishTypeName);
      }
      return all;
    }, []);

    if (noOrderDishTypeNameList.length) {
      this.setState({
        orderAgain: false,
        showSelfChoose: true,
      });
      this.setErrMsg(`${noOrderDishTypeNameList.join('、')} ${formatMessage(dishMenuText.selfChooseModalNotSelect)}`);
      return;
    }
    confirmOrder(orderedData);
  },

  getIsShowClose() {
    const {
      shopInfo: { openStatus },
      isAcceptTakeaway,
    } = this.props;
    const { isShowOpenStatus } = this.state;
    const isAcceptOrderClose = !openStatus && isAcceptTakeaway; // 是否接受预定
    return this.isShopClose() && isShowOpenStatus && !isAcceptOrderClose;
  },

  render() {
    const {
      activeDishTypeId,
      activeDishTypeIdIndex,
      dishTypesData,
      dishDetailData,
      // confirmOrder,
      takeawayServiceProps,
      openTimeList,
      isAcceptTakeaway,
      errorMessage,
      shopInfo,
      shopLogo,
      dishesDataDuplicate,
      load,
      tableAreaInfo,
      isAcceptOrder,
      operateUrl,
      operateImgUrl,
      swiperAdImgs,
      isHDL,
      guide,
      orderPageImage,
      wmCartImageUrl,
      tsCartImageUrl,
      pageIsLoaded,
      soldTopDishList,
      setNoMore,
      fullAdvertImgUrl,
      fullAdvertUrl,
      showFullscreenAd,
      changed,
    } = this.props;
    // actions
    const {
      activeDishType,
      toggleDishDetailPopup,
      toggleDishDescPopup,
      removeAllOrders,
      clearErrorMsg,
      isDataInitOver,
      saveOrderChangeItem,
      reinstateUndefined,
      clearBell,
      callMsg,
      callBell,
      setCanCall,
      serviceStatus,
      setCancelCanMsg,
    } = this.props;
    const {
      isShowSearch,
      allDiscount,
      dishClass,
      showDishCouponSuccess,
      showFixedCoupon,
      showCouponList,
      isShowAlreadyGotCoupon,
      flodUpAppendCss,
      floatingNavigationStatus,
      isShowLoginExceptionDialog,
      showLoginExceptionDesc,
      orderAgain,
      showMessage,
      ebuIsShowLoginExceptionDialog,
      showGoodsDetailModal,
      currentDishId,
      showSelfChoose,
      showSelfChooseMsg,
    } = this.state;
    const marketList = shopInfo.marketList;
    const marketListUpdate = shopInfo.marketListUpdate;
    const { enableMemberRegistry, discountProps, setErrorMsg } = this.props;
    const isMember = discountProps && discountProps.isMember;
    const ableAddPriceDiscount = discountProps && discountProps.ableAddPriceDiscount; // 是否开启加价折扣
    let dishPageTpl = this.props.dishPageTpl || 'default';
    const tableInfo = getTableInfoInSessionStorage(shopId);
    const changeShowData = helper.getOrderedDishes(dishesDataDuplicate); // 购物车数据（过滤掉不包含order的）
    const changeShowDataItems = changeShowData.reduce((changeItems, item) => {
      changeItems[item.id] = item;

      return changeItems;
    }, {});

    const openShopTimeStr = `${helper.formatOpenTime(openTimeList)}`;
    const openShopTime = openShopTimeStr ? (
      <div className="o-flex__fluid">
        <div>{helper.formatOpenTime(openTimeList)}</div>
      </div>
    ) : (
        ''
      );

    const openDialog = this.renderOpenDialog(shopInfo, isAcceptOrder, openShopTime);
    const isRegistry = (enableMemberRegistry && isMember === false) || false;

    let showReceiveCoupons = false;
    if (
      (!shopInfo.isOldMarketing && showCouponList && this.getReceiveCouponsStatus() && shopInfo.couponList.length !== 0) ||
      (shopInfo.isOldMarketing && showCouponList && this.getReceiveCouponsStatus() && shopInfo.marketCoupon && shopInfo.marketCoupon.coupId) ||
      isShowAlreadyGotCoupon
    ) {
      showReceiveCoupons = true;
    }

    const noBuyWeixinMini = !shopInfo.enableWeixinMini && !!isWeiXinMiniBrowser;

    const preOrderInfo = this.isShowPreOrder();
    const closeDialogIsShow = this.getIsShowClose();

    return (
      <div className="dish-menu-page">
        <div style={{ display: showGoodsDetailModal ? 'none' : 'block', height: '100%' }}>
          {!pageIsLoaded ? (
            <PreloadSkeleton />
          ) : (
              <div className="o-flex o-flex--column dish-menu">
                {changed && showMessage && (
                  <Toast errorMessage={formatMessage(containnerText1.dishMenuTestButton)} clearErrorMsg={this.clearErrorMsg} timeout={2000} />
                )}
                {isRegistry && (
                  <div className="register notice">
                    <a href={`/member/register${location.search}&returnUrl=${encodeURIComponent(location.href)}`}>
                      <FormattedMessage {...containnerText1.DishMenuApplicationgotoRegister} />
                    </a>
                    <p>
                      <FormattedMessage {...containnerText1.DishMenuApplicationregisterToGetGift} />
                    </p>
                  </div>
                )}
                {openDialog}
                <div className="o-flex o-flex__fluid o-flex--column dish-menu-main">
                  <DishMesthead
                    shopInfo={shopInfo}
                    shopLogo={shopLogo}
                    tableInfo={tableAreaInfo}
                    setSearchPage={this.setSearchPage}
                    isHDL={isHDL}
                    operateImgUrl={operateImgUrl}
                    operateUrl={operateUrl}
                    swiperAdImgs={swiperAdImgs}
                    setAllDiscount={this.setAllDiscount}
                    orderPageImage={orderPageImage}
                    isAcceptOrder={isAcceptOrder}
                    takeawayServiceProps={takeawayServiceProps}
                    discountProps={discountProps}
                    openShopTimeStr={openShopTimeStr}
                    openShopTime={openShopTime}
                    flodUpAppendCss={flodUpAppendCss}
                    isShowHalf={type === 'WM' || type === 'TS'}
                  />

                  <div ref="scrollWrap" className={`scroller-wrap o-flex__fluid ${dishPageTpl} ${dishClass || ''}`} onTouchTap={this.onDishTouchTap}>
                    <DishTypeScroller
                      theme={dishPageTpl}
                      dishTypesData={dishTypesData}
                      dishesData={dishesDataDuplicate}
                      activeDishTypeId={activeDishTypeId}
                      activeDishTypeIdIndex={activeDishTypeIdIndex}
                      diningForm={shopInfo.diningForm}
                      onDishTypeElementTap={activeDishType}
                    />
                    <DishScroller
                      changeShowDataItems={changeShowDataItems}
                      setNoMore={setNoMore}
                      isDataInitOver={isDataInitOver}
                      saveOrderChangeItem={saveOrderChangeItem}
                      theme={dishPageTpl}
                      dishTypesData={dishTypesData}
                      dishesData={dishesDataDuplicate}
                      changeShowData={changeShowData}
                      diningForm={shopInfo.diningForm}
                      activeDishTypeId={activeDishTypeId}
                      activeDishTypeIdIndex={activeDishTypeIdIndex}
                      onScroll={activeDishType}
                      marketList={marketList}
                      onOrderBtnTap={this.handleOrderDishChange}
                      reinstateUndefined={reinstateUndefined}
                      onPropsBtnTap={toggleDishDetailPopup}
                      onImageBtnTap={this.handleItemImageTab}
                      marketListUpdate={marketListUpdate}
                      shopInfo={shopInfo}
                      load={load}
                      getMarketCoupon={this.props.getMarketCoupons}
                      onScrolling={direction => {
                        this.setScrollTop(direction);
                      }}
                      dishClass={dishClass}
                      getDishClass={this.getDishClass}
                      showHotSpan={this.showHotSpans}
                      soldTopDishList={this.getDishHotElement(soldTopDishList, dishesDataDuplicate)}
                      showHandleInput={this.showHandleInput}
                      showCouponsList={this.showCouponsList}
                      hiddenCouponsList={this.hiddenCouponsList}
                      couponType={'dishMenu'}
                      showAlreadyGotCoupon={this.showAlreadyGotCoupon}
                      isHDL={isHDL}
                      hasAds={!!swiperAdImgs.length} // 是否有广告位 优化抖动
                    />
                  </div>
                </div>

                {isFormalMeal(shopInfo.diningForm) ? (
                  <QuickMenu
                    callBell={callBell}
                    clearBell={clearBell}
                    callMsg={callMsg}
                    callAble
                    dishes={dishesDataDuplicate}
                    serviceStatus={serviceStatus}
                    openTimeList={openTimeList}
                    showErrMsgFunc={setErrorMsg}
                    cancelCallMsg={() => {
                      setCancelCanMsg(null);
                    }}
                    updateCanCall={setCanCall}
                    tableInfo={tableInfo}
                    shopInfo={shopInfo}
                  />
                ) : (
                    false
                  )}
                {dishDetailData !== undefined ? (
                  <DishDetailContainer
                    changeShowDataItems={changeShowDataItems}
                    dish={dishDetailData}
                    sameRuleDishList={this.getSameRuleDishList(dishDetailData, dishesDataDuplicate)}
                    onCloseBtnTap={toggleDishDetailPopup}
                    onAddToCarBtnTap={this.onDishDetailAddBtnTap}
                    showHandleInput={this.showHandleInput}
                  />
                ) : (
                    false
                  )}
                {errorMessage.text ? <Toast errorMessage={errorMessage.text} clearErrorMsg={clearErrorMsg} timeout={errorMessage.timeout} /> : false}
                {isShowSearch && (
                  <SearchDish
                    dishesData={dishesDataDuplicate}
                    dishTypesData={dishTypesData}
                    diningForm={shopInfo.diningForm}
                    marketList={marketList}
                    isMember={isMember}
                    onOrderBtnTap={this.handleOrderDishChange}
                    onPropsBtnTap={toggleDishDetailPopup}
                    onImageBtnTap={toggleDishDescPopup}
                    setSearchPage={this.setSearchPage}
                    isHDL={isHDL}
                  />
                )}
                {floatingNavigationStatus && <FloatingNavigation shopInfo={this.props.shopInfo} />}
                {allDiscount && <div className="ads-column add-content">{allDiscount}</div>}
                {localStorage.getItem('shop_' + helper.getUrlParam('shopId') + helper.getUrlParam('type')) === null &&
                  helper.getUrlParam('type') === 'WM' &&
                  guide &&
                  this.props.guidStatus ? (
                    <DishGuid dishType={{ type: 'WM', showScan: false }} />
                  ) : (
                    ''
                  )}
                {((shopInfo.couponSuccessInfo && shopInfo.couponSuccessInfo.couponId && showDishCouponSuccess) || shopInfo.couponSuccess) && (
                  <DishCouponSuccess shopInfo={shopInfo} closeDishCouponSuccess={this.closeDishCouponSuccess} showFixedCoupon={showFixedCoupon} />
                )}
                {this.state.showHotSpan && (
                  <div onTouchTap={this.onDishTouchTap}>
                    <DishHotSlide
                      goBack={this.cancelHotSpan}
                      theme={dishPageTpl}
                      dishesData={dishesDataDuplicate}
                      diningForm={shopInfo.diningForm}
                      marketList={marketList}
                      onOrderBtnTap={this.handleOrderDishChange}
                      onPropsBtnTap={toggleDishDetailPopup}
                      onImageBtnTap={toggleDishDescPopup}
                      soldTopDishList={this.getDishHotElement(soldTopDishList, dishesDataDuplicate)}
                      showHandleInput={this.showHandleInput}
                    />
                  </div>
                )}
                {showFullscreenAd && <FullscreenAd imageUrl={fullAdvertImgUrl} link={fullAdvertUrl} />}

                {isShowLoginExceptionDialog && (
                  <div className="login-exception-tip">
                    <div className="login-exception-container">
                      <div className="login-exception-text">
                        <FormattedMessage {...containnerText1.systemException} />
                      </div>
                      <div className="login-exception-desc">{showLoginExceptionDesc}</div>
                    </div>
                  </div>
                )}
                {ebuIsShowLoginExceptionDialog && (
                  <div className="login-exception-tip">
                    <div className="login-exception-container">
                      <div className="login-exception-text">
                        <FormattedMessage {...containnerText1.systemException} />
                      </div>
                      <div className="login-exception-desc">
                        <FormattedMessage {...containnerText1.loginFailed} />
                      </div>
                    </div>
                  </div>
                )}

                {showReceiveCoupons && (
                  <ReceiveCoupons
                    handleClose={this.hiddenCouponsList}
                    couponList={shopInfo.couponList}
                    ruleId={shopInfo.ruleId || 0}
                    getCoupons={this.props.getMarketCoupons}
                    getCoupontoGuid={this.props.getCoupontoGuid}
                    isShowAlreadyGotCoupon={isShowAlreadyGotCoupon}
                    shopInfo={shopInfo}
                    couponType={1}
                    title={
                      isShowAlreadyGotCoupon
                        ? formatMessage(containnerText1.DishMenuApplicationgetSpecialGift)
                        : formatMessage(containnerText1.DishMenuApplicationgetSpecialGiftSuccess)
                    }
                  />
                )}
                {load && load.status && <Loading word={load.text} />}
                <HealthIcon />
                {showSelfChooseMsg && <Toast errorMessage={showSelfChooseMsg} clearErrorMsg={this.clearErrorMsg} isShowIcon={false} timeout={2000} />}
                {/* orderAgain再来一单场景不显示开台必点 最后选好了再校验弹框显示  显示打烊弹框也不显示必点菜 */}
                {!orderAgain && showSelfChoose && !closeDialogIsShow && (
                  <SelfChooseMustOrderCategory
                    setErrMsg={this.setErrMsg}
                    selfChooseDishList={this.props.selfChooseDishList}
                    orderedDishes={changeShowData}
                    onOrderBtnTap={this.handleOrderDishChange}
                    onConfirm={this.handleConfirmSelfChoose}
                    onPropsBtnTap={toggleDishDetailPopup}
                  />
                )}
              </div>
            )}
        </div>
        {showGoodsDetailModal && <GoodsDetailModal closeModal={this.toggleGoodsdDetailModal} dishId={currentDishId} />}

        {pageIsLoaded && (
          <div
            className={`o-flex__fixed ${dishPageTpl} ${this.state.dropInShoping ? 'dropin-shopcart-animation' : ''}`}
            style={{ zIndex: 10, position: 'fixed', left: 0, right: 0, bottom: 0 }}
          >
            <CartContainer
              orderAgain={orderAgain}
              ableAddPriceDiscount={ableAddPriceDiscount}
              isMember={isMember}
              isHDL={isHDL}
              shopInfo={shopInfo}
              dishes={changeShowData}
              dishesData={dishesDataDuplicate}
              dishTypesData={dishTypesData}
              takeawayServiceProps={takeawayServiceProps}
              openTimeList={openTimeList}
              isAcceptTakeaway={isAcceptTakeaway}
              onOrderBtnTap={this.handleOrderDishChange}
              // beforeConfirmOrder confirmOrder
              onBillBtnTap={this.beforeConfirmOrder}
              onClearBtnTap={removeAllOrders}
              urlType={type}
              isAcceptOrder={isAcceptOrder && !noBuyWeixinMini}
              toggleDishDescPopup={toggleDishDescPopup}
              wmCartImageUrl={wmCartImageUrl}
              tsCartImageUrl={tsCartImageUrl}
              showHandleInput={this.showHandleInput}
              changeShowDataItems={changeShowDataItems}
              onPropsBtnTap={toggleDishDetailPopup}
              isShowSearch={isShowSearch}
              // 饿了么企餐屏蔽快速导航
              getIsExpandCard={ebuHelper.isEbuEvn() ? () => { } : this.getIsExpandCard}
              theme={dishPageTpl}
              preOrderInfo={preOrderInfo}
            />
          </div>
        )}
        <div id="handleInputDOM" data-editable={shopInfo.goodsNumEditable} style={{ display: 'none' }} />
      </div>
    );
  },
});

const mapActionsToProps = dispatch => {
  const mergedActions = Object.assign({}, actions, commonActions);
  return bindActionCreators(mergedActions, dispatch);
};

module.exports = connect(
  state => state,
  mapActionsToProps,
)(DishMenuApplication);



// WEBPACK FOOTER //
// ./src/container/dish-menu/application.jsx